// extracted by mini-css-extract-plugin
module.exports = {"mdc-feed-section":"mdc-feed-section","mdc-feed-section__header":"mdc-feed-section__header","mdc-feed-section__actions":"mdc-feed-section__actions"};